// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

let base_url = "https://imake-app.com";



export const environment = {
  production: false,
  URLSite :"https://admin.codesroots.com/api/",
  paymob_accept_base_url: 'https://accept.paymob.com/api',
  paymob_api_key:
  'ZXlKMGVYQWlPaUpLVjFRaUxDSmhiR2NpT2lKSVV6VXhNaUo5LmV5SmpiR0Z6Y3lJNklrMWxjbU5vWVc1MElpd2ljSEp2Wm1sc1pWOXdheUk2TVRBeU5EYzFMQ0p1WVcxbElqb2lNVFl5TWpJMU1EUTFNUzR3TmpnMU1ESWlmUS5sYnh4WkNla1BJX3NhbExpYXprUXBWUHlPTnc3OTRwRnExT3I0YkVXRmlvTEQtTHA5ZDctN2RKNmllT2hEYjZUaXViWVdnOFpEWDl3cmFDYVpWNG5SQQ==',
  integrationId: '408709',
  iframeId: '238206',
  api_url: `${base_url}:3103/api`,
  PhotoPath: `${base_url}:3103/`
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
